import React, { useEffect, useState } from "react";
import {Outlet, useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { getOrigin } from "../../../actions/origin/origin";
import OriginListComponent from "../../../components/Definition/Origin/OriginListComponent";
import { deleteDriver, getDrivers } from "../../../actions/driver/driver";
import DriverListComponent from "../../../components/Definition/Driver/DriverListComponent";

export default function DriverScreen() {
    const [driver, setDriver] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();


    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getDrivers(params.toString());
                setLoading(false);
                setDriver(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <DriverListComponent lists={driver} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید راننده حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteDriver(id);
                    if (response.status === "success") {
                        toast.success("راننده حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف راننده");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
